var React = require('react');
var { Input, Button, Link, Text, SelectNative, SelectOption, Layout } = require('@metro-ui/core');
var LoginStore = require('../../stores/LoginStore.js');
var LoginActions = require('../../actions/LoginActions.js');
var ErrorCodes = require('../../utils/ErrorCodes.js');
var AppConstants = require('../../constants/AppConstants');
var PhonePrefixes = require('../../constants/PhonePrefixes').default;
var _ = require('lodash');
var Utils = require('../../utils/Utils.js');

var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var LoginPreferencesCardWrapper = require('./LoginPreferencesCardWrapper');
var defaultMessages = require('../../i18n/messages/default');

class TwoFaTotpViaSmsPopUp extends React.Component {
    constructor(props) {
        super(props);
        const userLocale = _.get(LoginStore.getState(), 'userDetails.userLocationDetails.countryCode', 'DE');
        const numberDetails = PhonePrefixes.find(el => el.key === userLocale)
        this.state = {
            code: '',
            isOtpSent: false,
            mobileNumber: '',
            prefix: numberDetails.label || '',
            numberInfo: numberDetails.info,
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.storeMobileNumber = this.storeMobileNumber.bind(this);
        this.validateOtpSentViaSms = this.validateOtpSentViaSms.bind(this);
        this.otpSentViaSmsListener = this.otpSentViaSmsListener.bind(this);
        this.totpAppValidationListener = this.totpAppValidationListener.bind(this);
        this._onBackNavigationClick = this.onBackNavigationClick.bind(this);
        this.handlePrefixChange = this.handlePrefixChange.bind(this);
        this.getNumberFormat = this.getNumberFormat.bind(this);
        this.phonePrefixes = _.sortBy(_.uniqBy(PhonePrefixes, 'label'), 'label', 'asc');
    }

    componentDidMount() {
        LoginStore.otpSentViaSmsListener(this.otpSentViaSmsListener);
    }

    componentWillUnmount() {
        LoginStore.removeOtpSentViaSmsListener(this.otpSentViaSmsListener);
        LoginStore.removeTotpAppValidationListener(this.totpAppValidationListener);
    }

    getNumberFormat() {
      const {mobileNumber, prefix} = this.state;

      return `${prefix.replace('+', '00')}${mobileNumber}`
    }

    onInputChange(ev, value) {
        if (value.length > 6)
            value = value.slice(0, 6)
        this.setState({ code: value });
    }

    otpSentViaSmsListener() {
        let appState = LoginStore.getState();

        if (appState.otpViaSms) {
            if (appState.otpViaSms.isOtpSent) {
                this.setState({ isOtpSent: true });
                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.msg_otpsent']), "success", true);

                return;
            } else if (_.includes(AppConstants.LoginPreferences.ERROR_CODES_WHERE_USER_REDIRECTS, appState.otpViaSms.errorCode)) {
                LoginActions.triggerToast(Utils.replaceAllByKeys(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.otpViaSms.errorCode]]), appState.otpViaSms.placeholders), "error",true)
                this.props.onNavItemClick(2);
            } else if (appState.otpViaSms.errorCode) {
                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.otpViaSms.errorCode]]), "error", true)
            }
            else {
                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]]), "error", true);
            }
        }
    }

    totpAppValidationListener() {
        let appState = LoginStore.getState();

        if (appState.validateTotpResponse) {
            if (appState.validateTotpResponse.isValid) {

                this.props.onNavItemClick(2, true); //pass true to GetUserDetails
                return;

            } else if (
                _.includes(
                    AppConstants.LoginPreferences.ERROR_CODES_WHERE_USER_REDIRECTS, appState.validateTotpResponse.errorCode)) {
                LoginActions.triggerToast(Utils.replaceAllByKeys(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.validateTotpResponse.errorCode]]), appState.validateTotpResponse.placeholders), "error",true)

                this.props.onNavItemClick(2);

            } else if (appState.validateTotpResponse.errorCode) {
                LoginActions.triggerToast(Utils.replaceAllByKeys(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.validateTotpResponse.errorCode]]), appState.validateTotpResponse.placeholders), "error",true)

            } else {
                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[ErrorCodes[AppConstants.GENERIC_ERROR_CODE]]), "error", true);
            }
        }
    }

    validateOtpSentViaSms() {
        LoginActions.validateTotpAddCode(
            this.props.idToken,
            this.props.userType,
            this.props.realmId,
            this.props.countryCode,
            this.props.traceId,
            this.state.code,
            this.getNumberFormat());
    }

    sendOtpViaSms(evt) {
        LoginActions.genAndSendOtpUsingTempSecret(this.props.userType, this.props.idToken,
          this.getNumberFormat(), this.props.countryCode, this.props.traceId);
    }

    storeMobileNumber(ev, value) {
        this.setState({ mobileNumber: value });
    }

    handlePrefixChange(_, value) {
      const prefixDetails = this.phonePrefixes.find(el => el.label === value) || {};
      if (prefixDetails.info) {
        this.setState({ numberInfo: prefixDetails.info });
      }
      this.setState({ prefix: value });
    }

    onBackNavigationClick() {
        this.props.onNavItemClick(2);    
    }

    render() {
        const label = this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.mobile_number']) + '*';
        const verificationCode = this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.otp']) + ':';
        const otpPlaceholderhint = this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.otp_hint']);
        return (
            <LoginPreferencesCardWrapper headingText={this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.setup'])}
            onBackNavigationClick= {this._onBackNavigationClick} showBackNavIcon={true}>
                <Text className= "margin-bottom-small" size= "medium">
                    {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.step_1'])}
                </Text>
                <Layout direction="row">
                  <SelectNative
                    id="phone-prefix"
                    name="phone-prefix"
                    className="select-prefix"
                    label={label}
                    value={this.state.prefix}
                    onChange={this.handlePrefixChange}
                  >
                    {this.phonePrefixes.map(el => <SelectOption value={el.label}>{el.label}</SelectOption>)}
                  </SelectNative>
                  <Input className= "form-controls mobile-input"
                    placeholder={this.state.numberInfo}
                    label={''}
                    value={this.state.mobileNumber}
                    onChange={this.storeMobileNumber}
                    isRequired
                  />
                </Layout>
                <div>
                    <Button isWide
                        size= 'medium'
                        className= "form-controls"
                        isFullWidth= {false}
                        variant='primary'
                        isDisabled={((this.state.mobileNumber).length < 4) || this.state.isOtpSent}
                        onClick={this.sendOtpViaSms.bind(this)}>
                        {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.send_otp'])}
                    </Button>
                </div>
                {this.state.isOtpSent &&
                    <React.Fragment>
                        <Text className= "margin-bottom-small" size= "medium">
                            {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.step_2'])}
                        </Text>
                        <Input
                            id="verificationCode"
                            placeholder={otpPlaceholderhint}
                            label={verificationCode}
                            className= "form-controls"
                            value={this.state.code}
                            onChange={this.onInputChange}
                            isRequired="true"
                            type="number" />
                        <div>
                            <Button isWide
                                variant='primary'
                                size= 'medium'
                                className="form-controls"
                                isDisabled={this.state.code.length <= 5}
                                onClick={this.validateOtpSentViaSms.bind(this)}>
                                {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.verify'])}
                            </Button>
                            <Link style={{ 'padding-left': '5%' }} href="" target="_blank"
                                onClick={this.sendOtpViaSms.bind(this)}>
                                {this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.codes_via_sms.resend_otp'])}
                            </Link>
                        </div>
                    </React.Fragment>
                }
            </LoginPreferencesCardWrapper>
        );
    }
}

module.exports = injectIntl(TwoFaTotpViaSmsPopUp);